export default __webpack_public_path__ + "static/media/skywatch.d96a2d28.png";